let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8Ptvx")).then(() => parcelRequire('4bbsk'));